import React, { useEffect, useState } from "react";
import "../../Styles/navbar.css";
import "./style/Doctorhome.css";
import { inject, observer } from "mobx-react";
import calllIcon from "../../Assets/callIcon.svg";
import searchIcon from "../../Assets/searchIcon.svg";
import NextPatientCard from "./NextPatientCard";
import { useHistory } from "react-router-dom";
import { Colors, HexColors } from "../../Utils/colors";
import DoctorPatients from "./DoctorPatients";
import DoctorHeader from "../Headers/DoctorHeader";
import DoctorSidebar from "../Headers/Doctorsidebar";
import axios from "axios";

const DoctorHome = inject("store")(
  observer(({ store, otherProp }) => {
    const history = useHistory();
    const [user, setUser] = useState("");
    const [medData, setMedData] = useState([]);
    const [showData, setShowData] = useState(false);
    const [blur, setBlur] = useState(false);

    useEffect(() => {
      axios
        .get("api/doc/doctors/", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.access,
          },
        })
        .then((res) => {
          console.log(res.data.data);
          if (res.data.data) {
            localStorage.setItem("userId", res.data.data.user);
            if (res.data.data.specialization.toString() === "1")
              store.updateColor(Colors.ayurvedic);
            else if (res.data.data.specialization.toString() === "2")
              store.updateColor(Colors.homeopathic);
            else store.updateColor(Colors.allopathic);
            setUser(res.data.data);
          }
        });
    }, [store]);

    const handleSearch = (e) => {
      if (e.target.value === "") {
        setBlur(false);
      }
      if (localStorage.access && localStorage.refresh) {
        axios
          .get(`api/vol/search/?query=${e.target.value}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.access,
            },
          })
          .then((res) => {
            console.log(res.data.data);
            setMedData(res.data.data);
          })
          .catch(() => console.log("Not Found"));

        setShowData(true);
      }
    };

    return (
      <div className="overflowX-hidden">
        <div className="mobile">
          <DoctorHeader user={user} />
        </div>
        <div class="flex">
          <div className="websites">
            <DoctorSidebar />
          </div>
          <div className="web">
            <div className="mt-2" onClick={() => setShowData(false)}>
              <div className="rounded-2xl mx-auto md:max-w-2xl p-1">
                <div className="header-doctor">
                  <div className="searchbar">
                    <div
                      className="flex justify-between h-10 mx-auto mt-10  text-black"
                      style={{
                        boxShadow: "0px 0px 10px 5px rgba(0, 0, 0, 0.03)",
                        borderRadius: "17px",
                        alignItems: "center",
                        width: "95%",
                      }}
                    >
                      <input
                        name="query"
                        placeholder="Search for hospitals,doctors etc"
                        onChange={(e) => {
                          handleSearch(e);
                          setBlur(true);
                        }}
                        autoComplete="off"
                        style={{ borderRadius: "17px", width: "100%" }}
                        type="text"
                        className="pl-4 outline-none search"
                      />
                      <img className=" h-3 mr-5 ml-5" src={searchIcon} alt="" />
                    </div>
                    {showData && (
                      <div
                        className="bg-white text-left mt-1.5"
                        style={{
                          color: "black",
                          width: "80%",
                          marginRight: "10px",
                          boxShadow: "0px 0px 10px 5px rgba(0, 0, 0, 0.03)",
                          borderRadius: "0px 0px 22px 22px",
                          fontSize: "12px !important",
                          position: "absolute",
                          zIndex: "5",
                        }}
                      >
                        {medData.map((data, index) => (
                          <>
                            <div
                              className="my-2 mx-2"
                              onClick={() => {
                                setBlur(false);
                              }}
                              style={{
                                color: "black",
                                borderRadius: "2px",
                                width: "18.25rem",
                                marginBottom: "12px",
                                marginRight: "10px",
                              }}
                              key={index}
                              // onClick={() => { setMedicine(data.med); setMed(data.id); setQuery(data.med); setShowData(false); }}
                            >
                              <div
                                className=" flex justify-between"
                                style={{ alignItems: "center" }}
                              >
                                <div className="">
                                  <p className="font-sm">{data.name}</p>
                                  <p
                                    className="font-xs"
                                    style={{ color: "rgba(210, 210, 210, 1)" }}
                                  >
                                    {data.type}
                                  </p>
                                </div>
                                {(data.type === "Hospital" ||
                                  data.type === "Ambulance" ||
                                  data.type === "Pharma") && (
                                  <>
                                    {" "}
                                    <div className="pr-3">
                                      <a href={`tel:${data.mobile}`}>
                                        <div
                                          style={{
                                            alignItems: " center",
                                            background: "#717EF0",
                                          }}
                                          className=" w-16 flex justify-around h-7 rounded-lg "
                                        >
                                          <p className=" font-semibold text-white">
                                            Call
                                          </p>
                                          <img src={calllIcon} alt="" />
                                        </div>
                                      </a>
                                    </div>{" "}
                                  </>
                                )}
                              </div>
                              <p
                                className="font-xs pb-2 mr-4"
                                style={{
                                  color: "#C0BABA",
                                  borderBottom: "1px solid #CACACA",
                                }}
                              >
                                {data.content}
                              </p>
                            </div>
                          </>
                        ))}
                      </div>
                    )}
                  </div>
                  <div
                    className="icon header-doctor mt-10"
                    style={{
                      alignItems: "center",
                      boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
                      borderRadius: "24px",
                    }}
                  >
                    <div
                      onClick={() =>
                        history.push("/doctorprofile", { user: user })
                      }
                      className="pl-4"
                    >
                      {user ? user.user_data.name : "Hello"}
                    </div>
                    <img
                      className="inline-block h-8 w-10 rounded-full ring-2 ring-white"
                      src={
                        user
                          ? user.user_data.profile_pic
                          : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      }
                      alt="Doctor_image"
                    />
                  </div>
                </div>

                <div className="namaste font-normal text-2xl mt-4 md:text-center ml-4 ">
                  Namaste
                </div>
                <div className="rest">
                  <div className="first">
                    <div
                      onClick={() => {
                        setBlur(false);
                      }}
                      style={{ filter: blur ? "blur(2px)" : "none" }}
                      className="mx-auto md:max-w-2xl p-2 md:flex align-middle block"
                    >
                      <div className="buttons-doctor mx-auto max-w-sm my-1 flex justify-around">
                        <button
                          className="text-xs w-24 h-24 m-1 text-white"
                          style={{
                            borderRadius: "10px",
                            alignItems: "center",
                            boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          <div className="mx-auto w-5 ">
                            <svg
                              className="-ml-1"
                              width="24"
                              height="32"
                              viewBox="0 0 24 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.40176 0.734235L6.23224 0.18368C7.23499 -0.118696 8.3135 -0.0459056 9.26652 0.388467C10.2195 0.822841 10.982 1.58912 11.4115 2.54432L12.8264 5.6908C13.1957 6.5124 13.2985 7.42901 13.1205 8.31203C12.9424 9.19505 12.4924 10.0002 11.8335 10.6144L9.49008 12.7994C9.42158 12.8632 9.37819 12.9495 9.36774 13.0425C9.29872 13.6652 9.72066 14.8777 10.6931 16.5639C11.4006 17.7889 12.0421 18.65 12.5864 19.1316C12.966 19.4688 13.1746 19.5409 13.264 19.5158L16.4167 18.5512C17.2777 18.2878 18.1995 18.3005 19.0529 18.5874C19.9064 18.8743 20.6486 19.4211 21.1757 20.1511L23.1849 22.9368C23.796 23.784 24.0788 24.824 23.981 25.864C23.8833 26.9039 23.4114 27.873 22.6532 28.5914L21.2635 29.9089C20.5259 30.6074 19.62 31.103 18.634 31.3473C17.648 31.5917 16.6156 31.5766 15.6372 31.3034C11.3174 30.0972 7.44472 26.4519 3.97512 20.4429C0.500822 14.426 -0.717928 9.24353 0.405141 4.89398C0.657951 3.91575 1.15849 3.01912 1.8585 2.29053C2.55852 1.56194 3.43441 1.02596 4.40176 0.734235ZM5.08094 2.98822C4.5007 3.16304 3.97524 3.48432 3.5552 3.92113C3.13515 4.35794 2.83465 4.89555 2.68265 5.48218C1.73839 9.14 2.81911 13.7342 6.01265 19.2665C9.20147 24.7908 12.635 28.022 16.2709 29.0384C16.8577 29.2019 17.4769 29.2106 18.0681 29.0638C18.6593 28.9171 19.2025 28.6197 19.6448 28.2008L21.0361 26.8832C21.3808 26.5567 21.5954 26.116 21.6398 25.6432C21.6842 25.1704 21.5555 24.6975 21.2776 24.3124L19.2699 21.5283C19.0303 21.1961 18.6927 20.9472 18.3045 20.8167C17.9163 20.6862 17.4969 20.6805 17.1053 20.8005L13.9447 21.7683C12.1095 22.3141 10.4438 20.8381 8.65562 17.7403C7.45099 15.6541 6.88946 14.0385 7.02906 12.7821C7.10278 12.1296 7.4055 11.5273 7.88548 11.0787L10.2289 8.89374C10.5285 8.61457 10.7332 8.24858 10.8142 7.84714C10.8952 7.44571 10.8485 7.02898 10.6806 6.65545L9.26578 3.50897C9.07053 3.07513 8.7242 2.72708 8.29132 2.52969C7.85845 2.33229 7.36857 2.29903 6.91298 2.43609L5.08094 2.98822Z"
                                fill={
                                  store.color === Colors.allopathic
                                    ? HexColors.allopathic
                                    : store.color === Colors.homeopathic
                                    ? HexColors.homeopathic
                                    : HexColors.ayurvedic
                                }
                              />
                            </svg>
                          </div>
                          <div
                            className="mt-4 font-semibold btn-text"
                            style={{
                              color:
                                store.color === Colors.allopathic
                                  ? HexColors.allopathic
                                  : store.color === Colors.homeopathic
                                  ? HexColors.homeopathic
                                  : HexColors.ayurvedic,
                            }}
                          >
                            Call
                          </div>
                        </button>

                        <button
                          className="text-xs w-24 h-24 m-1 text-white"
                          onClick={() =>
                            history.push("/community", { user: user })
                          }
                          style={{
                            borderRadius: "10px",
                            alignItems: "center",
                            boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          <div className="mx-auto w-5 ">
                            <svg
                              className="-ml-1"
                              width="30"
                              height="33"
                              viewBox="0 0 22 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M15.1583 4.23285C15.1583 6.58254 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58254 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285ZM10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16ZM16.9571 4.30922C16.9571 5.50703 16.5998 6.62288 15.973 7.55051C15.9086 7.64597 15.9659 7.77476 16.0796 7.79457C16.2363 7.82159 16.3984 7.8369 16.5631 7.8414C18.2062 7.88463 19.6809 6.82102 20.0883 5.21974C20.6918 2.84123 18.9198 0.705896 16.6634 0.705896C16.4181 0.705896 16.1835 0.732013 15.9551 0.778845C15.9238 0.78605 15.8907 0.800459 15.8728 0.828378C15.8513 0.862601 15.8674 0.908532 15.8889 0.938252C16.5667 1.8938 16.9571 3.05918 16.9571 4.30922ZM19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257ZM5.43711 7.84131C5.60186 7.83681 5.76304 7.8224 5.92063 7.79448C6.03434 7.77467 6.09165 7.64588 6.02718 7.55042C5.4004 6.62279 5.04313 5.50694 5.04313 4.30913C5.04313 3.05909 5.43353 1.89371 6.11135 0.938162C6.13284 0.908442 6.14806 0.862511 6.12746 0.828288C6.10956 0.80127 6.07553 0.78596 6.04509 0.778755C5.81586 0.731923 5.58127 0.705806 5.33593 0.705806C3.07951 0.705806 1.30751 2.84114 1.91191 5.21965C2.31932 6.82093 3.79405 7.88454 5.43711 7.84131ZM5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446Z"
                                fill={
                                  store.color === Colors.allopathic
                                    ? HexColors.allopathic
                                    : store.color === Colors.homeopathic
                                    ? HexColors.homeopathic
                                    : HexColors.ayurvedic
                                }
                              />
                            </svg>
                          </div>
                          <div
                            className="mt-4 font-semibold btn-text"
                            style={{
                              color:
                                store.color === Colors.allopathic
                                  ? HexColors.allopathic
                                  : store.color === Colors.homeopathic
                                  ? HexColors.homeopathic
                                  : HexColors.ayurvedic,
                            }}
                          >
                            Community
                          </div>
                        </button>
                        <button
                          onClick={() =>
                            history.push("/pharma", { user: user })
                          }
                          className="text-xs w-24 h-24 m-1 text-white"
                          style={{
                            borderRadius: "10px",
                            alignItems: "center",
                            boxShadow: "0px 0px 10px 4px rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          <div className="mx-auto w-5 ">
                            <svg
                              className="-ml-1"
                              width="30"
                              height="33"
                              viewBox="0 0 30 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask id="path-1-inside-1" fill="white">
                                <path d="M25.1573 13.0781C28.6671 15.719 30.3499 19.0468 29.9379 23.2604C29.5114 27.6507 26.3474 31.3149 21.953 32.5596C17.5327 33.8128 12.8098 32.3298 10.0147 28.7245C9.44127 27.9843 8.94564 27.6703 7.92269 27.7769C4.76449 28.1049 1.99242 26.4957 0.675545 23.7651C-0.589463 21.141 -0.0534916 17.8581 2.07887 15.7218C6.52224 11.2671 10.9887 6.83754 15.4666 2.41642C18.5787 -0.653414 23.0394 -0.807606 26.0218 2.00711C29.0244 4.83864 28.9985 9.08875 25.9584 12.2623C25.7308 12.4978 25.5002 12.7305 25.1573 13.0781ZM25.9325 16.1956C23.218 13.5127 20.129 12.467 16.527 13.3893C12.8703 14.3257 10.5593 16.7087 9.77265 20.2971C9.13295 23.2212 9.85046 25.8761 12.0232 28.1918C16.6884 24.1688 21.2355 20.2467 25.9325 16.1956ZM10.7956 9.19528C12.0721 10.3587 12.7637 11.0764 13.5533 11.6652C13.8558 11.8894 14.4523 11.9848 14.8068 11.8586C17.4434 10.9194 20.0483 10.9839 22.6792 11.8754C23.0106 11.9876 23.584 11.9511 23.8059 11.7437C24.5234 11.0708 25.2582 10.3559 25.7509 9.52609C27.0217 7.38702 26.4195 4.67884 24.4427 3.08926C22.5639 1.57817 19.6507 1.41837 17.9304 2.87339C15.5848 4.86107 13.3285 6.94407 10.7956 9.19528ZM13.5129 29.344C16.7086 32.0662 22.1058 31.685 25.3446 28.5899C28.3962 25.6714 29.1253 20.5831 26.8114 17.8721C22.3824 21.6961 17.9534 25.5145 13.5129 29.344ZM9.99453 11.1465C7.88234 13.1146 5.7788 15.0153 3.75882 16.9946C3.13064 17.6086 2.58314 18.3767 2.24024 19.1701C1.43628 21.0232 1.90021 22.7586 3.22285 24.2304C4.53108 25.6855 6.19663 26.2854 8.21661 25.9266C7.01787 20.3196 7.61436 17.4264 12.0462 13.2043C11.3229 12.481 10.5997 11.7549 9.99453 11.1465Z" />
                              </mask>
                              <path
                                d="M25.1573 13.0781C28.6671 15.719 30.3499 19.0468 29.9379 23.2604C29.5114 27.6507 26.3474 31.3149 21.953 32.5596C17.5327 33.8128 12.8098 32.3298 10.0147 28.7245C9.44127 27.9843 8.94564 27.6703 7.92269 27.7769C4.76449 28.1049 1.99242 26.4957 0.675545 23.7651C-0.589463 21.141 -0.0534916 17.8581 2.07887 15.7218C6.52224 11.2671 10.9887 6.83754 15.4666 2.41642C18.5787 -0.653414 23.0394 -0.807606 26.0218 2.00711C29.0244 4.83864 28.9985 9.08875 25.9584 12.2623C25.7308 12.4978 25.5002 12.7305 25.1573 13.0781ZM25.9325 16.1956C23.218 13.5127 20.129 12.467 16.527 13.3893C12.8703 14.3257 10.5593 16.7087 9.77265 20.2971C9.13295 23.2212 9.85046 25.8761 12.0232 28.1918C16.6884 24.1688 21.2355 20.2467 25.9325 16.1956ZM10.7956 9.19528C12.0721 10.3587 12.7637 11.0764 13.5533 11.6652C13.8558 11.8894 14.4523 11.9848 14.8068 11.8586C17.4434 10.9194 20.0483 10.9839 22.6792 11.8754C23.0106 11.9876 23.584 11.9511 23.8059 11.7437C24.5234 11.0708 25.2582 10.3559 25.7509 9.52609C27.0217 7.38702 26.4195 4.67884 24.4427 3.08926C22.5639 1.57817 19.6507 1.41837 17.9304 2.87339C15.5848 4.86107 13.3285 6.94407 10.7956 9.19528ZM13.5129 29.344C16.7086 32.0662 22.1058 31.685 25.3446 28.5899C28.3962 25.6714 29.1253 20.5831 26.8114 17.8721C22.3824 21.6961 17.9534 25.5145 13.5129 29.344ZM9.99453 11.1465C7.88234 13.1146 5.7788 15.0153 3.75882 16.9946C3.13064 17.6086 2.58314 18.3767 2.24024 19.1701C1.43628 21.0232 1.90021 22.7586 3.22285 24.2304C4.53108 25.6855 6.19663 26.2854 8.21661 25.9266C7.01787 20.3196 7.61436 17.4264 12.0462 13.2043C11.3229 12.481 10.5997 11.7549 9.99453 11.1465Z"
                                fill={
                                  store.color === Colors.allopathic
                                    ? HexColors.allopathic
                                    : store.color === Colors.homeopathic
                                    ? HexColors.homeopathic
                                    : HexColors.ayurvedic
                                }
                              />
                              <path
                                d="M25.1573 13.0781L22.3096 10.2691L19.0982 13.5248L22.7523 16.2744L25.1573 13.0781ZM29.9379 23.2604L25.9568 22.8711L25.9566 22.8737L29.9379 23.2604ZM21.953 32.5596L20.8629 28.7111L20.862 28.7113L21.953 32.5596ZM10.0147 28.7245L6.8527 31.1743L6.85347 31.1753L10.0147 28.7245ZM7.92269 27.7769L8.3359 31.7555L8.33701 31.7554L7.92269 27.7769ZM0.675545 23.7651L-2.92762 25.5021L-2.92736 25.5026L0.675545 23.7651ZM2.07887 15.7218L4.90988 18.5477L4.91091 18.5466L2.07887 15.7218ZM15.4666 2.41642L12.6576 -0.431278L12.6563 -0.430015L15.4666 2.41642ZM26.0218 2.00711L23.2764 4.91614L23.2775 4.91721L26.0218 2.00711ZM25.9584 12.2623L28.8344 15.0424L28.8407 15.0359L28.8469 15.0293L25.9584 12.2623ZM25.9325 16.1956L28.545 19.2246L31.825 16.3956L28.7444 13.3507L25.9325 16.1956ZM16.527 13.3893L17.5193 17.2643H17.5193L16.527 13.3893ZM9.77265 20.2971L5.86544 19.4406L5.86507 19.4423L9.77265 20.2971ZM12.0232 28.1918L9.1061 30.9287L11.7306 33.7259L14.6354 31.221L12.0232 28.1918ZM10.7956 9.19528L8.13832 6.20549L4.81648 9.15791L8.10116 12.1516L10.7956 9.19528ZM13.5533 11.6652L11.1622 14.8718L11.1713 14.8786L13.5533 11.6652ZM14.8068 11.8586L16.1481 15.627L16.149 15.6267L14.8068 11.8586ZM22.6792 11.8754L21.3954 15.6638L21.397 15.6644L22.6792 11.8754ZM23.8059 11.7437L26.5378 14.6655L26.542 14.6615L23.8059 11.7437ZM25.7509 9.52609L22.312 7.48311L22.3116 7.48384L25.7509 9.52609ZM24.4427 3.08926L21.9358 6.2062L21.9361 6.20643L24.4427 3.08926ZM17.9304 2.87339L15.3472 -0.180699L15.3444 -0.178266L17.9304 2.87339ZM13.5129 29.344L10.9006 26.3149L7.36649 29.3628L10.9191 32.389L13.5129 29.344ZM25.3446 28.5899L28.1081 31.4818L28.1093 31.4807L25.3446 28.5899ZM26.8114 17.8721L29.8538 15.2753L27.2422 12.2155L24.1973 14.8445L26.8114 17.8721ZM9.99453 11.1465L12.8305 8.32563L10.1002 5.58079L7.26772 8.22L9.99453 11.1465ZM3.75882 16.9946L6.5547 19.8552L6.55831 19.8517L3.75882 16.9946ZM2.24024 19.1701L5.90978 20.7621L5.91197 20.7571L2.24024 19.1701ZM3.22285 24.2304L0.24765 26.9041L0.24837 26.9049L3.22285 24.2304ZM8.21661 25.9266L8.91625 29.8649L12.9941 29.1405L12.1282 25.0903L8.21661 25.9266ZM12.0462 13.2043L14.8053 16.1004L17.7724 13.2737L14.8747 10.3759L12.0462 13.2043ZM22.7523 16.2744C25.3089 18.198 26.2146 20.2355 25.9569 22.8711L33.9189 23.6498C34.4853 17.8581 32.0253 13.24 27.5623 9.88188L22.7523 16.2744ZM25.9566 22.8737C25.6983 25.5328 23.7638 27.8894 20.8629 28.7111L23.0432 36.4082C28.9311 34.7404 33.3245 29.7686 33.9191 23.6472L25.9566 22.8737ZM20.862 28.7113C17.9582 29.5345 14.9378 28.5462 13.1759 26.2736L6.85347 31.1753C10.6818 36.1133 17.1072 38.0911 23.044 36.408L20.862 28.7113ZM13.1767 26.2746C12.7495 25.7232 12.0291 24.893 10.8902 24.3377C9.68727 23.7513 8.49553 23.6956 7.50836 23.7984L8.33701 31.7554C8.3728 31.7516 7.94035 31.7997 7.38436 31.5286C6.89234 31.2887 6.70648 30.9856 6.85271 31.1743L13.1767 26.2746ZM7.50947 23.7983C6.04338 23.9505 4.86933 23.2527 4.27845 22.0275L-2.92736 25.5026C-0.884487 29.7386 3.4856 32.2592 8.3359 31.7555L7.50947 23.7983ZM4.27871 22.0281C3.75706 20.946 3.96892 19.4903 4.90988 18.5477L-0.752147 12.896C-4.0759 16.2258 -4.93599 21.336 -2.92762 25.5021L4.27871 22.0281ZM4.91091 18.5466C9.34438 14.1018 13.8029 9.68009 18.2769 5.26285L12.6563 -0.430015C8.17444 3.99499 3.70011 8.43233 -0.753175 12.897L4.91091 18.5466ZM18.2757 5.26411C19.9962 3.56696 22.0008 3.71227 23.2764 4.91614L28.7673 -0.901928C24.078 -5.32748 17.1613 -4.87379 12.6576 -0.431278L18.2757 5.26411ZM23.2775 4.91721C24.0148 5.61254 24.2601 6.33739 24.2562 6.98181C24.2521 7.65076 23.9714 8.55419 23.0699 9.49529L28.8469 15.0293C30.9855 12.7969 32.2378 9.98847 32.256 7.03108C32.2744 4.04918 31.0314 1.23321 28.7661 -0.902999L23.2775 4.91721ZM23.0825 9.48222C22.8729 9.69897 22.6624 9.91144 22.3096 10.2691L28.0051 15.8871C28.338 15.5496 28.5886 15.2966 28.8344 15.0424L23.0825 9.48222ZM28.7444 13.3507C25.1862 9.83385 20.6969 8.19249 15.5348 9.51434L17.5193 17.2643C19.5611 16.7414 21.2499 17.1915 23.1206 19.0405L28.7444 13.3507ZM15.5348 9.51434C10.4458 10.8175 6.98255 14.3447 5.86544 19.4406L13.6799 21.1537C14.1361 19.0726 15.2949 17.8339 17.5193 17.2643L15.5348 9.51434ZM5.86507 19.4423C4.93711 23.6839 6.05314 27.6748 9.1061 30.9287L14.9402 25.4549C13.6478 24.0774 13.3288 22.7585 13.6802 21.152L5.86507 19.4423ZM14.6354 31.221C19.3008 27.1979 23.8481 23.2756 28.545 19.2246L23.32 13.1666C18.6229 17.2178 14.076 21.1397 9.41093 25.1626L14.6354 31.221ZM8.10116 12.1516C9.1273 13.0869 10.1643 14.1277 11.1622 14.8718L15.9444 8.45849C15.3632 8.02514 15.017 7.63061 13.4901 6.23894L8.10116 12.1516ZM11.1713 14.8786C12.0112 15.5012 12.919 15.7479 13.5437 15.8454C14.1625 15.942 15.1284 15.9899 16.1481 15.627L13.4654 8.09021C13.8376 7.95772 14.14 7.926 14.3123 7.91774C14.498 7.90882 14.6527 7.92168 14.7774 7.94115C14.9026 7.96068 15.0492 7.99491 15.2157 8.05656C15.37 8.11368 15.634 8.22843 15.9353 8.45174L11.1713 14.8786ZM16.149 15.6267C17.8569 15.0183 19.5325 15.0325 21.3954 15.6638L23.9629 8.08703C20.5641 6.93528 17.0298 6.82055 13.4646 8.09051L16.149 15.6267ZM21.397 15.6644C22.2291 15.9459 23.0505 15.972 23.6774 15.91C24.1541 15.8628 25.4478 15.6845 26.5378 14.6654L21.074 8.82187C21.5706 8.35754 22.0597 8.16103 22.288 8.0829C22.5479 7.99399 22.7572 7.96195 22.8898 7.94883C23.0916 7.92886 23.4607 7.91706 23.9614 8.08649L21.397 15.6644ZM26.542 14.6615C27.2274 14.0188 28.3697 12.9503 29.1903 11.5683L22.3116 7.48384C22.1467 7.76152 21.8194 8.12286 21.0697 8.82587L26.542 14.6615ZM29.1899 11.5691C31.5744 7.55516 30.3261 2.68749 26.9493 -0.0279146L21.9361 6.20643C22.2127 6.42889 22.3523 6.6951 22.3992 6.9196C22.4436 7.13234 22.4111 7.31637 22.312 7.48311L29.1899 11.5691ZM26.9496 -0.027683C23.8679 -2.50628 18.7969 -3.09837 15.3472 -0.180698L20.5135 5.92747C20.4632 5.97003 20.5798 5.8504 20.9678 5.86586C21.3492 5.88106 21.7096 6.02426 21.9358 6.2062L26.9496 -0.027683ZM15.3444 -0.178266C12.9528 1.84836 10.5946 4.02236 8.13832 6.20549L13.4529 12.1851C16.0624 9.86578 18.2167 7.87378 20.5164 5.92504L15.3444 -0.178266ZM10.9191 32.389C15.8752 36.6108 23.5841 35.805 28.1081 31.4818L22.5811 25.698C20.6275 27.5649 17.542 27.5216 16.1068 26.299L10.9191 32.389ZM28.1093 31.4807C30.3358 29.3513 31.6632 26.5021 32.052 23.7036C32.4354 20.944 31.9542 17.7361 29.8538 15.2753L23.7689 20.4689C23.9824 20.7191 24.2937 21.4108 24.1281 22.6028C23.9679 23.7559 23.4051 24.91 22.58 25.6991L28.1093 31.4807ZM24.1973 14.8445C19.7694 18.6675 15.3417 22.4847 10.9006 26.3149L16.1253 32.3731C20.5651 28.5442 24.9954 24.7247 29.4254 20.8998L24.1973 14.8445ZM7.26772 8.22C5.21555 10.1321 3.02689 12.1116 0.95933 14.1375L6.55831 19.8517C8.53071 17.919 10.5491 16.097 12.7213 14.073L7.26772 8.22ZM0.962946 14.134C0.000930756 15.0743 -0.862067 16.2657 -1.4315 17.5832L5.91197 20.7571C6.02835 20.4878 6.26035 20.1429 6.5547 19.8552L0.962946 14.134ZM-1.42931 17.5781C-2.97332 21.1371 -1.9082 24.505 0.24765 26.9041L6.19805 21.5568C5.8983 21.2233 5.85145 21.0341 5.84642 21.0105C5.84368 20.9976 5.84285 20.9891 5.84481 20.9713C5.84697 20.9515 5.85682 20.8842 5.90978 20.7621L-1.42931 17.5781ZM0.24837 26.9049C2.47784 29.3845 5.53124 30.4662 8.91625 29.8649L7.51696 21.9882C7.08619 22.0648 6.86334 22.014 6.75666 21.9772C6.6494 21.9402 6.46037 21.8486 6.19733 21.556L0.24837 26.9049ZM12.1282 25.0903C11.5716 22.4867 11.5844 21.1386 11.8683 20.1369C12.1422 19.1708 12.8248 17.9871 14.8053 16.1004L9.28716 10.3081C6.83574 12.6435 5.00424 15.0175 4.17154 17.9553C3.34894 20.8575 3.6629 23.7594 4.305 26.7628L12.1282 25.0903ZM14.8747 10.3759C14.1548 9.656 13.4342 8.93259 12.8305 8.32563L7.15859 13.9674C7.7651 14.5772 8.49106 15.306 9.21772 16.0327L14.8747 10.3759Z"
                                fill={
                                  store.color === Colors.allopathic
                                    ? HexColors.allopathic
                                    : store.color === Colors.homeopathic
                                    ? HexColors.homeopathic
                                    : HexColors.ayurvedic
                                }
                                mask="url(#path-1-inside-1)"
                              />
                            </svg>
                          </div>
                          <div
                            className="mt-4 font-semibold btn-text"
                            style={{
                              color:
                                store.color === Colors.allopathic
                                  ? HexColors.allopathic
                                  : store.color === Colors.homeopathic
                                  ? HexColors.homeopathic
                                  : HexColors.ayurvedic,
                            }}
                          >
                            {" "}
                            Prescription
                          </div>
                        </button>
                      </div>
                    </div>
                    <div className="card">
                      <NextPatientCard />
                    </div>
                  </div>
                  <div
                    className="second mt-4"
                    style={{
                      backgroundColor:
                        store.color === Colors.allopathic
                          ? "#F5F5FF"
                          : store.color === Colors.homeopathic
                          ? "#EFF6FF"
                          : "#EFFCFF",
                    }}
                  >
                    <div className="heading flex justify-around pt-4 ">
                      <div className="sub-heading">Patients Under Care</div>
                      <div
                        className="mt-1"
                        style={{
                          marginRight: "-51px",
                          color: "#717EF0",
                          textDecorationColor: "#717EF0",
                          textDecorationLine: "underline",
                          fontSize: "10px",
                        }}
                      >
                        View all
                      </div>
                    </div>
                    <div className="mx-auto patient-card ">
                      <DoctorPatients patientName="Sejal" status="Patient" />
                      <DoctorPatients patientName="Sejal" status="Patient" />
                      <DoctorPatients patientName="Sejal" status="Patient" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  })
);

export default DoctorHome;
